import { defineComponent, h } from 'vue';
import { CToastClose } from './CToastClose.js';

const CToastHeader = defineComponent({
    name: 'CToastHeader',
    props: {
        /**
         * Automatically add a close button to the header.
         */
        closeButton: Boolean,
    },
    emits: [
        /**
         * Event called after clicking the close button.
         */
        'close',
    ],
    setup(props, { slots, emit }) {
        return () => h('div', { class: 'toast-header' }, [
            slots.default && slots.default(),
            props.closeButton &&
                h(CToastClose, {
                    onClose: () => emit('close'),
                }),
        ]);
    },
});

export { CToastHeader };
//# sourceMappingURL=CToastHeader.js.map
